import { useEffect, useState } from "react";
import { api, fmtErr } from "../lib/api";

export const TwoFactorPanel = ({ stage, preToken, email, onSuccess }) => {
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (stage === "setup_2fa") {
      api.twofaSetup(preToken).then(setSetup).catch(e => setErr(fmtErr(e)));
    }
  }, [stage, preToken]);

  const verify = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true); setErr("");
    try {
      const r = await api.twofaVerify(preToken, code);
      onSuccess(r.token, r.user);
    } catch (e2) {
      setErr(fmtErr(e2));
      setBusy(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="twofa-panel">
      {stage === "setup_2fa" && (
        <div className="space-y-3">
          <p className="text-sm text-zinc-600">
            Scan this QR code with an authenticator app (Google Authenticator, Microsoft Authenticator, Authy…), then enter the 6-digit code it shows.
          </p>
          {setup ? (
            <div className="flex flex-col items-center gap-2">
              <img data-testid="twofa-qr" src={`data:image/png;base64,${setup.qr_png_b64}`} alt="2FA QR code" className="w-44 h-44 border border-zinc-200 rounded-md" />
              <details className="text-[11px] text-zinc-500 text-center">
                <summary className="cursor-pointer hover:text-zinc-700">Can't scan? Enter the key manually</summary>
                <code data-testid="twofa-secret" className="block mt-1 font-mono bg-zinc-100 rounded px-2 py-1 break-all select-all">{setup.secret}</code>
              </details>
            </div>
          ) : !err && <div className="text-sm text-zinc-400 text-center py-8">Generating your secure key…</div>}
        </div>
      )}
      {stage === "verify_2fa" && (
        <p className="text-sm text-zinc-600">
          Enter the 6-digit code from your authenticator app for <strong>{email}</strong>.
        </p>
      )}
      <form onSubmit={verify} className="space-y-3">
        <input
          data-testid="twofa-code"
          value={code}
          onChange={e => setCode(e.target.value.replace(/[^0-9 ]/g, ""))}
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={7}
          autoFocus
          placeholder="123 456"
          className="block w-full h-12 rounded-md border border-zinc-200 px-3 text-center text-xl font-mono tracking-[0.3em] focus:outline-none focus:ring-1 focus:ring-zinc-950 focus:border-zinc-950"
        />
        {err && <p data-testid="twofa-error" className="text-sm text-rose-600">{err}</p>}
        <button
          data-testid="twofa-verify-btn"
          type="submit"
          disabled={busy || code.replace(/\D/g, "").length < 6}
          className="w-full h-10 rounded-md bg-zinc-950 text-white text-sm font-medium hover:bg-zinc-800 disabled:opacity-40 transition-colors"
        >
          {busy ? "Verifying…" : "Verify & sign in"}
        </button>
      </form>
    </div>
  );
};
